import React, {useContext, useEffect} from "react"
import Row from "@amzn/meridian/row";
import Table, {
    TableRow,
    TableCell,
    TableSectionHeader,
} from "@amzn/meridian/table"
import Text from "@amzn/meridian/text";
import {LineHaulFilterContext} from "../linehaul/context/LineHaulFilterContext";
import {ContainerDetailContext} from "./context/ContainerContext";
import {FormattedMessage} from "react-intl";
import Link from "@amzn/meridian/link";
import {getRefreshInterval, getSplitViewHeaders} from "../util/Util";
import RefreshTimer from "../util/RefreshTimer";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const Container = () => {
    const {filter} = useContext(LineHaulFilterContext)
    const {viewModel, dispatch} = useContext(ContainerDetailContext)
    const {isMobile} = useDeviceLayout();

    const getPackageListUrl = (lineHaulId, containerId, packageState) => {
        return "#packageList/" + lineHaulId + "/" + containerId + "/" + packageState + "/" + filter + "/Induct"
    };

    const getDataForContainer = () => {
        dispatch({type: 'LOAD_VIEW', data: {filter: filter, dispatcher: dispatch}});
    }

    const isGroupedMetric = (groupedContainerMetrics) => {
        return groupedContainerMetrics &&
            (groupedContainerMetrics.doubleGroupedMetric || groupedContainerMetrics.singleGroupedMetric);
    };

    const isValidLinehaul = (containerDetail) => {
        if (!containerDetail) return false
        const pendingInductContainer = containerDetail.filter(containerDetail => containerDetail.pendingInductVolume > 0)
        return pendingInductContainer.length > 0 ? true : false
    }

    useEffect(() => {
        getDataForContainer()
        const interval = setInterval(() => {
            if (!document.hidden) {
                getDataForContainer();
            }
        }, getRefreshInterval());
        return () => clearInterval(interval);
    }, [filter.PackageSize, filter.EAD, filter.Cycle, filter.CPT, filter.Cluster, filter.OtherAttributes])

    return (
        <div>
            <Row width="100%" widths={isMobile ? ["grid-12"]: ["grid-8"]}>
                <div>
                    <RefreshTimer deps={[viewModel.containerDetail]}/>
                    <Row width="100%" widths={["grid-12"]} spacingInset="medium none none">
                        <div style={{ overflowX: "auto", width: "100%" }}>
                            <Table showDividers={false} spacing="small" headerRows={1}
                                   headerColumns={1}
                                   fixHeaderRows = {true}
                                   fixHeaderRowsFullWidth={true}
                                   stickyHeaderColumn={true}>
                                <TableRow>
                                    <TableCell columnSpan={1}>
                                        <FormattedMessage id="induct.container_id" defaultMessage="ID"/>
                                    </TableCell>
                                    <TableCell columnSpan={2} alignmentHorizontal="right">
                                        <FormattedMessage id="induct.type" defaultMessage="Type"/>
                                    </TableCell>
                                    <TableCell columnSpan={7} alignmentHorizontal="right">
                                        <FormattedMessage id="induct.pending_induct" defaultMessage="Pending Induct "/>
                                        /
                                        <FormattedMessage id="induct.total" defaultMessage="Total"/>
                                    </TableCell>
                                </TableRow>
                                {viewModel.lineHaulList
                                    .filter(lineHaul => isValidLinehaul(viewModel.containerDetail[lineHaul]))
                                    .map(lineHaul => {
                                            return [
                                                <TableSectionHeader key={lineHaul}>LineHaul {lineHaul}</TableSectionHeader>,
                                                Object.keys(viewModel.containerDetail).indexOf(lineHaul) !== -1 ?
                                                    viewModel.containerDetail[lineHaul].map(containerDetail =>
                                                        containerDetail.pendingInductVolume > 0 ?
                                                            (
                                                                <TableRow key={containerDetail.containerId}
                                                                          highlightOnHover={isGroupedMetric(containerDetail.groupedContainerMetrics)}
                                                                          open={viewModel.expandableCells.includes(containerDetail.containerId)}
                                                                          onClick={
                                                                              isGroupedMetric(containerDetail.groupedContainerMetrics) ?
                                                                              () => dispatch({
                                                                              type: 'EXPAND_CONTAINER_DATA',
                                                                              data: containerDetail.containerId
                                                                          }) : null}>
                                                                    <TableCell columnSpan={1}>
                                                                        <Text type="h100">{containerDetail.containerId}</Text>
                                                                    </TableCell>
                                                                    <TableCell columnSpan={2}
                                                                               alignmentHorizontal="right">{containerDetail.containerType}</TableCell>
                                                                    <TableCell columnSpan={7} alignmentHorizontal="right">
                                                                        {containerDetail.pendingInductVolume > 0 ?
                                                                            <Link
                                                                                href={getPackageListUrl(lineHaul, containerDetail.containerId, "PENDING_INDUCT")}
                                                                                type="secondary">{containerDetail.pendingInductVolume} </Link>
                                                                            : 0} / &nbsp;
                                                                        {containerDetail.volume}
                                                                    </TableCell>
                                                                    {containerDetail.groupedContainerMetrics && containerDetail.groupedContainerMetrics.doubleGroupedMetric &&
                                                                    <TableRow>
                                                                        <TableCell> </TableCell>
                                                                        {Object.keys(getSplitViewHeaders(containerDetail.groupedContainerMetrics.doubleGroupedMetric)).map((key, index) => (
                                                                            <TableCell width={"150px"} key={index}>
                                                                                <Text type="h100">
                                                                                    {key}
                                                                                </Text></TableCell>
                                                                        ))}
                                                                    </TableRow>
                                                                    }
                                                                    {containerDetail.groupedContainerMetrics && containerDetail.groupedContainerMetrics.singleGroupedMetric &&
                                                                    <TableRow><TableCell> </TableCell></TableRow>
                                                                    }
                                                                    {containerDetail.groupedContainerMetrics && containerDetail.groupedContainerMetrics.doubleGroupedMetric
                                                                    && Object.entries(containerDetail.groupedContainerMetrics.doubleGroupedMetric).map(([key, value], index) => (
                                                                        <TableRow key={index}>
                                                                            <TableCell header={true} width={"150px"}>
                                                                                <Text type="h100">
                                                                                    {key}
                                                                                </Text>
                                                                            </TableCell>
                                                                            {Object.values(value).map((volume, index) => (
                                                                                <TableCell key={index} width={"150px"}>
                                                                                    {volume['PENDING_INDUCT']} / &nbsp; {volume['ALL']}</TableCell>
                                                                            ))}
                                                                        </TableRow>
                                                                    ))}
                                                                    {containerDetail.groupedContainerMetrics && containerDetail.groupedContainerMetrics.singleGroupedMetric &&
                                                                    Object.entries(containerDetail.groupedContainerMetrics.singleGroupedMetric).map(([key, value], index) => (
                                                                        <TableRow key={index}>
                                                                            <TableCell header={true} width={"150px"}>
                                                                                <Text type="h100">
                                                                                    {key}
                                                                                </Text>
                                                                            </TableCell>
                                                                            <TableCell
                                                                                width={"150px"}> {value['PENDING_INDUCT']} / &nbsp; {value['ALL']}</TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableRow>
                                                            ) : null
                                                    ) : null
                                            ]
                                        }
                                    )}
                            </Table>
                        </div>
                    </Row>
                </div>
            </Row>
        </div>
    )
}

export default Container


// WEBPACK FOOTER //
// ./src/components/induct/Container.js